<template>
  <FloatingInput
    v-model="valueModel"
    type="email"
    :disabled="disabled"
    :input-class="inputClass"
    :label-class="labelClass"
    :label="label"
    :show-valid-icon="validate && !readonly"
    :error="error"
    :readonly="readonly"
    :is-dark-floating-label="isDarkFloatingLabel"
  />
</template>

<script>
import { MAX_EMAIL_LENGTH } from '@/constants';
import FloatingInput from '@/components/FloatingInput';
import { validateEmail } from '@/utilities/validators';

export default {
  components: {
    FloatingInput,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: 'Email',
    },
    readonly: {
      type: Boolean,
    },
    inputClass: {
      type: String,
      default: '',
    },
    labelClass: {
      type: String,
      default: '',
    },
    isDarkFloatingLabel: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    valueModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    validate() {
      if (!this.value?.length || this.value?.length > MAX_EMAIL_LENGTH) {
        return false;
      }
      return validateEmail(this.value);
    },
  },
};
</script>
